/**
 * The token on each request, when something other than the client holds it
 * (STE-1012: the Auth0 SDK).
 *
 * Kept apart from the client so the rule can be checked without a browser.
 */

/** Gives a token; `fresh` asks for a new one rather than the one held. */
export type TokenSource = (fresh?: boolean) => Promise<string>

let source: TokenSource | null = null
export const setTokenSource = (s: TokenSource | null) => { source = s }
export const tokenSource = () => source

/**
 * Sends with the token held. A refusal gets one renewal and one more try, and
 * no more: a token that is refused fresh is not going to be accepted by asking
 * again.
 */
export async function sendWithToken(
  send: (token: string | null) => Promise<Response>, src: TokenSource,
): Promise<Response> {
  const first = await send(await src(false))
  if (first.status !== 401) return first
  return send(await src(true))
}
